import { setError } from 'state-management/actions/errors';

export const generateError = (constant, error) => setError(constant, error);
